import classNames from "classnames";

import styles from "./typography.module.css";

const variantsMapping = {
    body: "p",
    "body-bold": "p",
    "body-semibold": "p",
    caption1: "p",
    "caption1-semibold": "p",
    caption2: "p",
    "caption2-bold": "p",
    footnote: "p",
    "footnote-bold": "p",
    "footnote-semibold": "p",
    headline: "p",
    title1: "h1",
    title2: "h2",
    title3: "h3",
} as const;

type Typography = {
    children: React.ReactNode;
    className?: string;
    color?: "primary" | "white";
    element?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "p" | "span";
    variant?: keyof typeof variantsMapping;
};

export function Typography({ children, className, color = "primary", element, variant, ...htmlProps }: Typography) {
    const Component = element ? element : variant ? variantsMapping[variant] : "p";

    return (
        <Component
            className={classNames(className, {
                [styles[`typography--color-${color}`]]: color,
                [styles[`typography--variant-${variant}`]]: variant,
            })}
            {...htmlProps}
        >
            {children}
        </Component>
    );
}
